import { createSlice } from '@reduxjs/toolkit';
import { REDUX_ASYNC_STATUSES } from '../../consts/consts';

const { IDLE, LOADING, SUCCEEDED, FAILED } = REDUX_ASYNC_STATUSES;

const initialState = {
  getOrganizationsToRisksStatus: IDLE,
  organizationsToRisks: [],

  bulkAddOrganizationsToRisksStatus: IDLE,
  bulkRemoveOrganizationsToRisksStatus: IDLE,

  createOrganizationsToRisksStatus: IDLE,
  updateOrganizationsToRisksStatus: IDLE
};

const organizationsToRisksSlice = createSlice({
  name: 'organizationsToRisks',
  initialState,
  reducers: {
    getOrganizationsToRisks: (state) => {
      state.getOrganizationsToRisksStatus = LOADING;
    },
    getOrganizationsToRisksSucceeded: (state, action) => {
      state.getOrganizationsToRisksStatus = SUCCEEDED;
      state.organizationsToRisks = action.payload;
    },
    getOrganizationsToRisksFailed: (state) => {
      state.getOrganizationsToRisksStatus = FAILED;
    },
    bulkAddOrganizationsToRisks: (state) => {
      state.bulkAddOrganizationsToRisksStatus = LOADING;
    },
    bulkAddOrganizationsToRisksSucceeded: (state) => {
      state.bulkAddOrganizationsToRisksStatus = SUCCEEDED;
    },
    bulkAddOrganizationsToRisksFailed: (state) => {
      state.bulkAddOrganizationsToRisksStatus = FAILED;
    },

    bulkRemoveOrganizationsToRisks: (state) => {
      state.bulkRemoveOrganizationsToRisksStatus = LOADING;
    },
    bulkRemoveOrganizationsToRisksSucceeded: (state) => {
      state.bulkRemoveOrganizationsToRisksStatus = SUCCEEDED;
    },
    bulkRemoveOrganizationsToRisksFailed: (state) => {
      state.bulkRemoveOrganizationsToRisksStatus = FAILED;
    },

    createOrganizationsToRisks: (state) => {
      state.createOrganizationsToRisksStatus = LOADING;
    },
    createOrganizationsToRisksSucceeded: (state) => {
      state.createOrganizationsToRisksStatus = SUCCEEDED;
    },
    createOrganizationsToRisksFailed: (state) => {
      state.createOrganizationsToRisksStatus = FAILED;
    },

    updateOrganizationsToRisks: (state) => {
      state.updateOrganizationsToRisksStatus = LOADING;
    },
    updateOrganizationsToRisksSucceeded: (state) => {
      state.updateOrganizationsToRisksStatus = SUCCEEDED;
    },
    updateOrganizationsToRisksFailed: (state) => {
      state.updateOrganizationsToRisksStatus = FAILED;
    }
  }
});

export const {
  getOrganizationsToRisks,
  getOrganizationsToRisksSucceeded,
  getOrganizationsToRisksFailed,
  bulkAddOrganizationsToRisks,
  bulkAddOrganizationsToRisksSucceeded,
  bulkAddOrganizationsToRisksFailed,
  bulkRemoveOrganizationsToRisks,
  bulkRemoveOrganizationsToRisksSucceeded,
  bulkRemoveOrganizationsToRisksFailed,
  createOrganizationsToRisks,
  createOrganizationsToRisksSucceeded,
  createOrganizationsToRisksFailed,
  updateOrganizationsToRisks,
  updateOrganizationsToRisksSucceeded,
  updateOrganizationsToRisksFailed
} = organizationsToRisksSlice.actions;

export default organizationsToRisksSlice.reducer;
